/**
 * Create stakes "by params" sequencer.
 *
 * @private
 * @param {String[]} keys – parameter names
 * @return {function(a:Immutable.Map<string, *>, b:Immutable.Map<string, *>):number} – sequencer
 */
export function createStakeSlotsByParamsSequencer(keys) {
  return (a, b) => {
    for (let i = 0; i < keys.length; i++) {
      const path = ['params', keys[i]];
      const result = (a.getIn(path) || 0) - (b.getIn(path) || 0);
      if (result !== 0) {
        return result;
      }
    }

    return 0;
  };
}

/**
 * Default stake slots sequencer.
 *
 * @param {SlotEntry} a
 * @param {SlotEntry} b
 * @return {number}
 */
export const defaultStakeSlotsSequencer = (a, b) => {
  return (
    (typeof a.name === 'string' && typeof b.name === 'string') && a.name.localeCompare(b.name)
  ) || a.id - b.id;
};
